import i18next from "i18next";
import { enGB, nb, pl, sv } from "date-fns/locale";
import { resolveLanguage } from "./languages";

const DATE_FNS_LOCALES = { enGB, nb, pl, sv };

/** date-fns locale object for the given i18n language (default: Norsk). */
export function dateFnsLocaleFor(language) {
  return DATE_FNS_LOCALES[resolveLanguage(language).dateFnsLocale];
}

/** date-fns locale for the active UI language (month/day names follow the user's language). */
export const currentDateFnsLocale = () => dateFnsLocaleFor(i18next.language);
